import { Component, input } from '@angular/core';
import { AvatarSize } from '@app/shared/types/enums/avatar-size.enum';

const projectAvatarSizes = new Map([
  [AvatarSize.SM, 'h-16 w-16'],
  [AvatarSize.MD, 'h-20 w-20'],
  [AvatarSize.LG, 'h-40 w-full']
]);

@Component({
  selector: 'proffeo-project-avatar',
  templateUrl: './project-avatar.component.html',
  styleUrl: './project-avatar.component.scss'
})
export class ProjectAvatarComponent {
  public readonly url = input<string>(undefined);
  public readonly projectName = input<string>(undefined);
  public readonly size = input<AvatarSize.SM | AvatarSize.MD | AvatarSize.LG>(AvatarSize.MD);

  protected getProjectAvatarSize(): string {
    return projectAvatarSizes.get(this.size()) || 'h-20 w-20';
  }
}
